export default __webpack_public_path__ + "static/media/carlos-delich.a4965d1f.webp";